import styled from "styled-components";
import { propertiesOfP } from "@/lib/styles";

export const Container = styled.div`
  padding: 2.5rem 0;
  background-color: ${({theme})=>theme.colors.white};
  
  ${({theme})=>theme.mediaQueries.laptop}{
    padding: 2.5rem 1.5rem;
  }
  
  .CookieDeclarationType {
    margin: 2rem 0;
  }
  
  p {
    ${propertiesOfP}
  }
`;
